export const GET_ACCESS_TOKEN = '/smarttech/v1/token'
export const GET_SCHEME = '/smarttech/v1/schemes'
export const GET_CARD = '/smarttech/v1/card'
export const FRAUDULENT = '/smarttech/v1/fraudulent'
